export const defaultNumberOfPlayers = 8;